









































import { Component, Vue, Prop } from "vue-property-decorator";
import { FormFieldProps, FormFieldRules, IFormField, EnumDTO } from "../../Models/Components.model";
import ButtonList from "../Common/Buttons/ButtonList.vue";
import ParticaBaseForm from "../Base/ParticaBaseForm.vue";
import { PublicationModel } from "../../Generated/ParticaAPI";

@Component(
	{
		name: "PublicationForm",
		components: { ButtonList }
	})
export default class PublicationForm extends ParticaBaseForm<PublicationModel> {

	private nameconfig =
		{
			props: { name: "name", placeholder: "Enter name", label: "Title Name", disabled: true } as FormFieldProps,
			rules: { required: true, } as FormFieldRules
		} as IFormField;

	private guidconfig =
		{
			props: { name: "guid", placeholder: "Enter guid", label: "guid", disabled: true, } as FormFieldProps,
			rules: { required: true, } as FormFieldRules
		} as IFormField;

	private languageconfig =
		{
			props: {
				name: "language", placeholder: "Choose language", label: "Language", required: true, disabled: true,
				values: [
					{ label: "English", value: "english" } as EnumDTO,
					{ label: "German", value: "german" } as EnumDTO,
					{ label: "Swedish", value: "swedish" } as EnumDTO,
					{ label: "Spanish", value: "spanish" } as EnumDTO,
				],
			} as FormFieldProps,
			rules: { required: true, numeric: true } as FormFieldRules
		} as IFormField;

	private publicationTypeconfig =
		{
			props: {
				name: "publicationType",
				placeholder: "Choose publicationType",
				label: "publicationType",
				required: true,
				disabled: true,
				values: [
					{ label: "Website Title", value: "title" } as EnumDTO,
					{ label: "Newsletter Service", value: "newsletterservice" } as EnumDTO,
					{ label: "Newsletter Subscription", value: "newslettersubscription" } as EnumDTO,
					{ label: "Purchased Articles", value: "myarticles" } as EnumDTO,
					{ label: "Written Articles", value: "written" } as EnumDTO,
					{ label: "Content Stream", value: "contentstream" } as EnumDTO,
					{ label: "Content Stream Subscription", value: "contentStreamSubscription" } as EnumDTO,
				],
			} as FormFieldProps,
			rules: { required: true, numeric: true } as FormFieldRules
		} as IFormField;

}
